import styled from "styled-components";

export const ExerciseListBox = styled.div`
  gap: 2px;
  width: calc(100vw - 32px);
  display: flex;
  position: relative;
  flex-direction: column;
`;

export const ExerciseListTit = styled.h3`
  color: ${(props) => props.theme.colors.text4};
  display: flex;
  font-size: 1.8rem;
  font-weight: 600;
  align-items: center;
  justify-content: space-between;
`;

export const ExerciseList = styled.ul`
  gap: 8px;
  width: calc(100vw - 16px);
  display: flex;
  padding: 10px 16px 10px 0;
  position: relative;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;
